import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import Button from '../../../../../components/Button';
import { SubscriptionAppBarSpacer } from '../../../components/SubscriptionAppBar';
import { inAppCancellation as events } from '../../../../../lib/analytics/events';
import { centsToDollarsNumber, expectUnreachable } from '../../../../../lib/util';
import { useLocation } from 'react-router-dom';
import { BaseInAppCancellationState } from '../../util/types';
import { SpecialOfferKey } from './SpecialOffers';

export interface SpecialOffersConfirmationState extends BaseInAppCancellationState {
  selectedOffer: SpecialOfferKey;
}

export default function SpecialOffersConfirmation() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();
  const location = useLocation<SpecialOffersConfirmationState>();
  const { selectedOffer } = location.state;

  const monthlyPrice = centsToDollarsNumber(device.subscription?.subscriptionOption?.priceInCents ?? 0);
  const descriptionText = () => {
    switch (selectedOffer) {
      case SpecialOfferKey.ONE_MONTH:
        return t('youll_save_amount_on_your_next_month_of_fi_membership_and_be_charged_0', { amount: monthlyPrice });
      case SpecialOfferKey.TWO_MONTHS:
        return t('youll_save_amount_on_your_next_two_months_of_fi_membership_and_be_charged_price_per_month', {
          amount: monthlyPrice,
          price: (monthlyPrice / 2).toFixed(2),
        });
      default:
        expectUnreachable(selectedOffer);
        throw new Error(`Unknown special offer type: ${selectedOffer}`);
    }
  };

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBarSpacer />
        <div className={styles.subscriptionContainer}>
          <h1>{t('youre_all_set')}</h1>
          <p>{descriptionText()}</p>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.specialOffersConfirmationDoneClicked({ petId: device.pet?.id });
              window.open('fi://closeappview');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
